module.exports = __webpack_public_path__ + "static/media/carta_11.0e215f0b.jpg";